module.exports = __webpack_public_path__ + "resources/img/main06.5115480a625326bc1fd0a5ab5da5c6b6.png";